export default "__VITE_ASSET__BNn0J7ye__"